import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";

import { analyticsGroupingsListSelector } from "src/store/system/selector";
import { updelsertAnalyticGrouping } from "src/apiService/modules/analyticsGroupings";
import { AnalyticsGroupingItem } from "src/interfaces/systemState.interface";
import { userRoleSelector } from "src/store/system/selector";

import DeleteButton from "../DeleteButton";
import AddEditDialog from "./AddEditAnalyticsGroupingsDialog";
import ProfileSettingsTable, {
  sortRowsByKey,
  useProfileSettingsTableInputStyles,
} from "../ProfileSettingsTable";

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
  actionButtons: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
}));

function AnalyticsGroupings({ className }) {
  const classes = useStyles();
  const tableInputClasses = useProfileSettingsTableInputStyles();
  const [open, setOpen] = useState<AnalyticsGroupingItem | boolean>(false);
  const analyticsGroupingsList = useSelector(analyticsGroupingsListSelector);
  const userRole = useSelector(userRoleSelector);
  const isViewer = userRole === "viewer";
  const sortedAnalyticsGroupings = useMemo(
    () => sortRowsByKey(analyticsGroupingsList, (row) => row.department || ""),
    [analyticsGroupingsList]
  );

  return (
    <>
      <AddEditDialog open={open} onClose={() => setOpen(false)} />
      <Grid item xs={12} className={className}>
        <Typography className={classes.bold}>Analytics Groupings</Typography>
      </Grid>
      <Grid item xs={12}>
        <ProfileSettingsTable
          columns={[
            { id: "department", label: "Department", width: "30%" },
            { id: "category", label: "Category", width: "30%" },
            { id: "subcategory", label: "Sub-Category", width: "30%" },
            { id: "actions", label: " ", width: 96, align: "center" },
          ]}
        >
          {sortedAnalyticsGroupings.map((row) => (
            <TableRow
              key={`${row.department}-${row.category}-${row.subcategory}`}
            >
              <TableCell className={tableInputClasses.tableCellDense}>
                {row.department}
              </TableCell>
              <TableCell className={tableInputClasses.tableCellDense}>
                {row.category}
              </TableCell>
              <TableCell className={tableInputClasses.tableCellDense}>
                {row.subcategory}
              </TableCell>
              <TableCell
                className={tableInputClasses.tableCellDense}
                align="center"
              >
                <Box className={classes.actionButtons} component="span">
                  <IconButton
                    onClick={() => setOpen(row)}
                    disabled={isViewer}
                    size="small"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <DeleteButton
                    disabled={isViewer}
                    onClick={async () =>
                      await updelsertAnalyticGrouping({ delete: row })
                    }
                  />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </ProfileSettingsTable>
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={() => setOpen(true)}
          variant="contained"
          color="primary"
          disabled={isViewer}
        >
          Add
        </Button>
      </Grid>
    </>
  );
}

export default AnalyticsGroupings;
